import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { NgxSpinnerService } from 'ngx-spinner';
import { ParametroService } from 'src/app/services/parametro.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { AgregarEditarParametroComponent } from './agregar-editar-parametro/agregar-editar-parametro.component';
import { RolOperacionService } from 'src/app/services/rol-operacion.service';

@Component({
  selector: 'app-parametro',
  templateUrl: './parametro.component.html',
  styleUrls: ['./parametro.component.scss'],
  providers: [SecurityService],

})
export class ParametroComponent implements OnInit {
  @ViewChild(AgregarEditarParametroComponent, { static: true }) modalAddEdit: AgregarEditarParametroComponent;

  listaParametros: any[];

  // FILTROS
  nombreParametro: string;
  busquedaEstado: number;

  // UTILS
  rut_empresa: number;
  rut_usuario: number;
  codigo_sucursal: number;
  // ROLES
  canAddParametro: boolean;
  canEditParametro: boolean;

  // LOG
  private log: any;

  constructor(
    private spinner: NgxSpinnerService,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private parametroService: ParametroService,
    private rolOperacion: RolOperacionService,
  ) { 
    this.log = this.clog.log('PARAMETROS');
    this.busquedaEstado = 1;
    this.listaParametros = [];
  }

  ngOnInit() {
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.rut_usuario = this.accesolocalstorage.getRutUsuario();
    this.codigo_sucursal = this.accesolocalstorage.getSucursalCodigo();
    this.canOperacionRol();
    this.buscar();
  }

  buscar(){
    this.listaParametros = [];
    this.nombreParametro = this.nombreParametro ? this.nombreParametro : '';
    
    const inputParams = {
      empresa_rut: this.rut_empresa,
      parametro: this.nombreParametro,
      estado: this.busquedaEstado,
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1,
    }
    this.spinner.show();
    this.parametroService.obtenerParametrosConFiltro(inputParams, ({mensajes, respuesta}) => {
      const registros: any[] = respuesta.registros;
      for (let i = 0; i < registros.length; i++) {
        const parametro = registros[i];
        if (parametro.valor_empresa && parametro.valor_sucursal) {
          parametro.valor = parametro.valor_empresa;
          parametro.instancia = 'Empresa';
          this.listaParametros.push({...parametro});
          parametro.valor = parametro.valor_sucursal;
          parametro.instancia = 'Sucursal';
          this.listaParametros.push({...parametro});
        }else if (parametro.valor_empresa) {
          parametro.valor = parametro.valor_empresa;
          parametro.instancia = 'Empresa';
          this.listaParametros.push({...parametro});
        } else if (parametro.valor_sucursal) {
          parametro.valor = parametro.valor_sucursal;
          parametro.instancia = 'Sucursal';
          this.listaParametros.push({...parametro});
        }else {
          this.listaParametros.push({...parametro});
        }
      }   
      this.spinner.hide();
    })
  }

  showModalAgregarParametro(){
    if (this.canAddParametro) this.modalAddEdit.showAddModal();
    else this.toastrService.error('No tienes permisos para agregar parametros', 'Error', { progressBar: true, timeOut: 10000 });
  }

  showModalEditarParametro(codigo: number) {
    if (this.canEditParametro) this.modalAddEdit.showEditModal(codigo);
    else this.toastrService.error('No tienes permisos para editar parametros', 'Error', { progressBar: true, timeOut: 10000 });
  }

  cambiarEstado(parametro: any){
    if (!this.canEditParametro) {
      this.toastrService.error('No tienes permisos para cambiar el estado del parametro', 'Error', { progressBar: true, timeOut: 10000 });
      return;
    }

    if (!confirm('Esta seguro de cambiar el estado de este parametro?')) return;
    this.spinner.show();
    this.parametroService.cambiarEstadoParametro(parametro.codigo, ({mensajes, respuesta}) => {
      console.log('response', mensajes, respuesta);
      this.buscar();
    });
    this.spinner.hide();
  }
  // 18: agregar. 19: editar
  canOperacionRol(){
    const input18: any = {
      rut_usu: this.accesolocalstorage.getRutUsuario(),
      cod_operacion: 18,
      codgo_modulo: 146,
    }
    this.rolOperacion.operacionPermitida(input18, (response: boolean) => {
      this.canAddParametro = response;
    });

    const input19: any = {
      rut_usu: this.accesolocalstorage.getRutUsuario(),
      cod_operacion: 19,
      codgo_modulo: 146,
    }
    this.rolOperacion.operacionPermitida(input19, (response: boolean) => {
      this.canEditParametro = response;
    });
  }
}
